export default __webpack_public_path__ + "static/media/Step-8.3f48fc56.webm";